const OverviewWigglingMicrobesBackground = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      viewBox='0 0 400 312'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'
    >
      <path
        d='M64.4253 107.97L64.6088 110.353'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M88.0979 116.321L88.1876 118.92'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M100.863 101.622L100.463 102.996'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M81.5559 97.1738C81.5559 97.2459 81.5559 97.3179 81.6012 97.6631C81.6464 98.0083 81.7369 98.6245 81.8302 99.2594'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M72.5015 118.719C72.5094 119.261 72.5173 119.803 72.5178 120.267C72.5182 120.73 72.511 121.099 72.5035 121.48'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M51.302 103.444C51.302 103.458 51.302 103.471 51.4077 103.654C51.5134 103.837 51.7248 104.189 51.9426 104.551'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M67.3977 95.2012C67.3977 95.3423 67.3977 95.4835 67.4007 95.7671C67.4037 96.0506 67.4096 96.4724 67.4157 96.907'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M48.771 122.565L49.1637 123.265'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M39.0918 104.688L39.2399 104.956'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M54.1774 95.1279L54.1514 95.5436'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M40.0445 116.009L40.0044 117.244'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M63.2637 121.957C63.2637 121.987 63.2637 122.017 63.2903 122.325C63.3169 122.632 63.37 123.216 63.4248 123.818'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M53.0396 113.398V113.422'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M74.1277 105.251L74.2868 105.986'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M92.3152 107.708V107.724'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M91.3336 96.3633L91.2795 96.7359'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M80.439 112.953L80.3333 113.249'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M81.1348 127.871L80.8669 128.016'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M68.4621 130.624L68.3059 130.878'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M98.042 140.205C98.042 140.21 98.042 140.216 97.992 140.36C97.942 140.504 97.842 140.788 97.739 141.08'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M107.705 128.833L107.4 129.227'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M96.5771 121.048C96.5771 121.141 96.5771 121.234 96.6458 121.573C96.7144 121.913 96.8517 122.497 96.9932 123.098'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M85.7751 138.669L85.5068 139.221'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M91.4893 129.135C91.5199 129.216 91.5505 129.297 91.7579 129.634C91.9653 129.971 92.3485 130.563 93.1258 131.613'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M111.177 111.852C111.177 111.879 111.177 111.906 111.059 112.144C110.94 112.382 110.703 112.828 110.459 113.289'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M111.668 100.788L111.546 101.164'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M103.388 91.3027C103.374 91.3642 103.36 91.4257 103.345 91.6711C103.331 91.9164 103.317 92.3438 103.303 92.7842'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M84.6956 90V90.0404'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M52.0003 133.929L51.9512 134.679'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M62.5542 142.418L62.6827 142.806'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M61.0032 132.935L61.082 132.98'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M75.3607 139.556C75.355 139.556 75.3492 139.556 75.2021 139.601C75.055 139.646 74.7666 139.735 74.4386 140C74.1105 140.264 73.7515 140.701 73.3816 141.151'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M70.2836 155.152L70.2129 155.17'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M80.2708 156.245L80.588 157.051'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M83.4296 150.037L83.2148 150.107'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M75.0889 148.414L74.7898 148.438'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M96.1567 149.937L97.291 151.773'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M95.2767 161.348C95.2767 161.353 95.2767 161.359 95.1855 161.484C95.0943 161.61 94.9119 161.855 94.7239 162.108'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M90.6532 145.072L90.5981 145.639'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M88.5769 158.682C88.5654 158.704 88.554 158.726 88.484 158.884C88.414 159.043 88.2857 159.337 88.1536 159.641'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M82.3008 167.81L82.3178 168.532'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M91.0277 167.344L91.0237 167.523'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M102.136 157.444L102.105 157.456'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M106.74 166.145L106.928 167.386'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M99.877 166.982L99.8969 167.218'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M106.695 136.127L106.897 137.764'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M99.4851 130.995H99.5296'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M100.741 113.162C100.793 113.276 100.846 113.39 100.972 113.604C101.099 113.818 101.299 114.129 101.505 114.45'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M106.796 120.977L108.834 121.771'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M118.737 92.4811C118.743 92.4692 118.749 92.4573 118.405 92.7689C118.062 93.0805 117.369 93.7158 116.509 94.5447'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M120.17 105.652L121.489 106.736'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M128.648 98.0664L129.003 98.3689'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M131.929 106.921C131.936 106.999 131.942 107.076 132.013 107.347C132.085 107.619 132.221 108.081 132.361 108.558'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M122.888 115.086C122.888 115.078 122.888 115.069 123.078 115.015C123.269 114.961 123.65 114.861 124.379 114.717'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M118.124 122.298C118.194 122.385 118.265 122.472 118.416 122.655C118.568 122.839 118.798 123.117 119.036 123.403'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M83.531 105.533C83.5737 105.533 83.6165 105.533 83.9834 105.547C84.3503 105.56 85.04 105.588 85.7507 105.617'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M143.989 142.018C143.995 142.018 144 142.018 143.876 142.35C143.752 142.683 143.499 143.349 143.238 144.035'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M134.249 140.689L135.184 142.153'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M150.435 106.332C150.407 106.395 150.38 106.459 150.204 106.834C150.029 107.21 149.707 107.895 149.375 108.602'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M141.263 114.485L141.319 114.817'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M139.596 100.991L139.622 100.495'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M131.744 119.723C131.744 119.739 131.744 119.755 131.811 119.997C131.879 120.239 132.015 120.706 132.155 121.187'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M142.157 129.14L144.26 131.017'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M124.267 130.206L123.448 131.705'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M123.695 146.522C123.688 146.552 123.68 146.582 123.729 146.857C123.778 147.132 123.884 147.651 123.993 148.083C124.102 148.515 124.212 148.846 124.325 149.186'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M130.648 152.87C130.648 152.957 130.648 153.044 130.623 153.32C130.598 153.595 130.548 154.057 130.405 154.511C130.263 154.965 130.029 155.397 129.788 155.842'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M116.051 135.098L116.024 135.264'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M114.592 129.109H114.617'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M114.725 144.977C114.466 145.326 114.206 145.676 113.821 146.344C113.435 147.012 112.932 147.986 112.413 148.991'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M103.902 145.865L104.913 147.401'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M119.094 154.121L118.44 156.244'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M110.177 157.01L110.727 157.816'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M119.928 165.452C119.923 165.474 119.917 165.496 119.987 165.784C120.058 166.071 120.205 166.623 120.442 167.374'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M123.363 139.874C123.393 139.94 123.423 140.007 123.533 140.135C123.642 140.263 123.83 140.449 124.023 140.642'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M132.121 130.238L132.235 130.548'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M126.107 122.736H126.083'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M140.17 122.083H140.689'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M152.581 118.886L152.344 119.684'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M157.096 112.995V113.253'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M138.603 106.599C138.608 106.599 138.614 106.599 139.079 106.667C139.544 106.736 140.47 106.874 141.423 107.015'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M160.015 103.346C160.02 103.472 160.025 103.598 160.029 103.816C160.033 104.035 160.037 104.343 160.041 104.66'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M146.019 96.999C146.065 97.0271 146.111 97.0552 146.265 97.1548C146.419 97.2544 146.679 97.4246 146.948 97.6'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M143.353 162.096C143.347 162.096 143.341 162.096 143.564 162.4C143.786 162.703 144.237 163.31 144.607 163.772C144.978 164.234 145.254 164.533 145.539 164.841'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M138.534 151.607L138.7 152.599'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M134.318 165.368L134.092 166.593'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M126.011 165.181L126.44 165.681'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M124.148 157.636L124.301 157.786'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M192.132 176.01L192.841 179.499'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M181.176 136.073L181.148 136.146'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M206.473 214.381L207.129 224.017'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M14.5139 164.711L13.8774 166.057'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M6.25812 202.334L5.90723 202.418'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M228.035 292.63L223.601 294.829'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M252.827 265.769L252.994 265.949'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M245.123 222.855L246.942 225.286'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M246.971 193.067L241.979 195.843'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M215.236 181.576L217.496 183.771'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M209.616 147.038L207.381 149.125'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M180.186 152.128C180.113 153.071 180.04 154.013 179.989 155.154C179.937 156.295 179.909 157.606 179.88 158.957'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M169.08 176.838L171.229 178.488'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M165.462 136.853C165.439 136.853 165.416 136.853 165.518 137.401C165.62 137.949 165.848 139.044 166.082 140.173'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M180.296 116.946L174.806 120.506'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M157.648 160.544L157.962 161.974'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M204.64 249.12C204.64 249.097 204.64 249.075 204.584 249.644C204.529 250.213 204.417 251.375 204.302 252.572'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M228.573 242.204L228.667 242.132'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M229.221 218.526L228.438 218.33'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M188.616 200.688C188.616 200.71 188.616 200.731 188.58 201.685C188.543 202.64 188.471 204.527 188.396 206.472'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M216.427 163.73C217.901 164.543 219.374 165.356 220.644 166.001C221.913 166.646 222.933 167.097 223.984 167.563'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M198.045 132.372L197.747 134.251'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M197.409 160.471L197.148 162.894'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M172.102 194.621L169.337 196.327'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M155.417 144.58L156.2 144.856'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M158.819 178.204L157.881 180.047'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M148.227 176.748L142.97 180.068'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M138.119 172.109L137.911 172.606'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M59.3271 168.681L61.5703 174.704'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.4111 140.782L29.6967 141.151'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M57.1492 154.756L58.9363 155.06'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M69.3604 164.251L69.4665 164.356'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M42.9697 148.925C43.0168 148.861 43.0639 148.798 43.6972 148.503C44.3305 148.209 45.5486 147.686 46.8035 147.146'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M19.6194 122.476L23.1514 122.055'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M39.5459 128.416L39.0767 129.465'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M26.9471 107.462C26.7385 108.37 26.5299 109.278 26.4965 110.328C26.463 111.379 26.6111 112.545 26.7636 113.746'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M8.48486 117.321L11.6579 116.829'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M20.2846 110.021L20.1785 109.953'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M32.3674 101.926L32.3191 101.995'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.7632 130.731L31.1907 128.645'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M33.6373 121.175L33.4292 121.872'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M10.834 136.217L5.53198 134.919'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M11.0552 129.027C11.0552 129.005 11.0552 128.983 11.6346 128.968C12.214 128.954 13.3728 128.949 14.5668 128.943'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M42.7566 158.091L42.5486 160.17'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M33.805 171.692L32.9155 173.034'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M26.7524 153.755L25.2468 153.619'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M13.4774 147.314L12.4329 148.36'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M20.8184 139.905C20.8184 139.926 20.8184 139.948 21.4738 140.314C22.1293 140.68 23.4402 141.391 24.7908 142.124'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M43.8833 138.78L43.4834 139.99'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M34.4737 150.991L34.0249 151.704'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.7677 165.005L29.6616 165.498'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M248.725 296.021L247.75 301.132'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M245.796 313.078L245.22 314.813'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M199.396 302.963L203.719 300.184'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M207.425 283.988L207.784 289.314'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M216.974 279.149L222.382 278.008'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M230.481 264.067L230.979 262.517'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M217.54 257.555L214.975 259.101'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M198.05 271.752L201.292 268.769'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M199.012 255.817L196.891 255.717'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M197.552 243.019L197.124 237.564'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M195.997 228.855L193.921 226.752'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M197.16 192.843L198.433 192.739'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M180.952 170.223V171.148'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M170.572 163.643L170.503 163.431'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M166.654 147.791V147.687'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M156.756 130.571H156.649'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M162.697 122.304H162.905'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M170.438 130.351L171.393 131.076'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M148.108 153.497C148.117 153.497 148.126 153.497 148.494 153.433C148.863 153.368 149.591 153.24 151.263 153.076'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M161.592 154.654C161.703 154.764 161.813 154.874 162.086 155.085C162.358 155.296 162.79 155.604 163.235 155.922'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M160.667 168.414L160.447 168.703'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M155.349 172.45L154.478 170.625'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M160.747 191.25H163.268'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M154.848 187.591C153.874 187.488 152.9 187.385 152.125 187.304C151.351 187.223 150.804 187.168 150.241 187.11'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M175.25 190.329L178.729 191.487'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M162.955 185.548L162.987 185.503'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M166.307 170.374V170.523'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M179.014 179.46C178.984 179.5 178.953 179.54 179.685 180.064C180.417 180.588 181.912 181.595 183.451 182.632'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M173.124 185.321H173.213'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M168.931 187.706H168.983'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M176.315 202.193L176.115 203.359'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M167.993 205.136L167.94 205.034'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M129.687 174.196L129.725 176.049'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M114.947 171.536H114.895'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M74.1789 172.083C74.1789 172.071 74.1789 172.06 73.8131 172.398C73.4474 172.735 72.7159 173.422 71.4749 174.724'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M49.7277 166.956C49.5407 167.104 49.3536 167.252 49.0133 167.457C48.6729 167.662 48.185 167.921 47.6824 168.187'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M54.0928 148.062L55.0924 148.494'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M51.5912 177.944C51.3906 178.422 51.1901 178.9 51.0279 179.394C50.8657 179.888 50.7479 180.385 50.6001 181.304'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M43.8358 178.249L42.8994 178.243'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M35.0034 184.562L35.0434 184.76'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M35.2292 181.557L35.2493 183.577'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M24.1579 174.422C23.5873 174.37 23.0166 174.319 22.1314 174.322C21.2463 174.326 20.0639 174.387 18.8457 174.45'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M21.9079 161.514C21.8904 161.461 21.8729 161.408 21.7518 161.128C21.6307 160.847 21.4065 160.34 21.1755 159.817'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M6.70663 157.288C6.19115 156.742 5.67567 156.195 4.95117 155.397C4.22666 154.598 3.30876 153.564 2.36304 152.499'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M0.193115 146.204C0.344529 146.085 0.495943 145.966 1.05073 145.604C1.60552 145.241 2.55909 144.639 3.54156 144.019'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M5.32455 124.096L5.30469 124.044'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-0.618328 135.588L-3.48755 137.348'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-4.81242 169.472C-4.82386 169.472 -4.8353 169.472 -4.28264 168.919C-3.72998 168.365 -2.61288 167.259 -1.46193 166.116'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-3.03223 182.667L1.21145 184.979'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M6.32227 173.603L7.45247 175.021'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M13.881 182.262L13.7749 182.963'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M22.3843 186.362C22.6743 186.544 22.9644 186.726 23.8843 187.225C24.8043 187.724 26.3453 188.535 27.9331 189.37'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M22.992 193.875C22.9806 193.875 22.9691 193.875 22.5877 194.201C22.2063 194.528 21.4553 195.181 20.7885 195.9C20.1216 196.62 19.5617 197.387 18.7708 198.595'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M10.5802 191.086C10.2013 191.111 9.82248 191.136 9.27535 191.18C8.72822 191.223 8.02431 191.285 7.29907 191.348'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M13.73 205.34C13.73 205.367 13.73 205.395 13.7482 205.875C13.7663 206.356 13.8027 207.29 13.8401 208.252'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M1.6891 210.551L-5.19336 210.851'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M6.78589 217.881L7.86713 218.874'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M1.80688 225.515L2.42503 226.136'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-5.45654 236.316C-4.23244 236.188 -3.00834 236.06 -1.36193 235.93C0.28449 235.8 2.31613 235.673 4.44604 235.535'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-0.618652 243.689C-0.0863476 244.243 0.445957 244.797 1.19932 245.578C1.95268 246.359 2.91096 247.351 3.89828 248.373'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-3.48755 282.932C-3.06157 283.804 -2.63559 284.675 -2.18432 285.423C-1.73304 286.17 -1.26938 286.767 -0.791664 287.382'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M4.18219 295.348L4.09302 295.325'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M2.89307 269.459L2.90513 269.539'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-0.472151 199.875L-0.516602 199.847'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M-2.06323 311.175C-2.03295 311.131 -2.00267 311.086 -1.58094 310.8C-1.15921 310.514 -0.346962 309.989 0.489905 309.445'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M6.03613 308.446C6.23936 308.346 6.4426 308.245 6.88276 308.076C7.32292 307.906 7.99385 307.671 8.68511 307.429'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M9.58105 313.034L9.62349 312.996'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M186.301 306.827L186.673 306.072'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M193.819 314.129C193.819 314.123 193.819 314.117 193.846 313.742C193.872 313.367 193.925 312.624 193.98 311.858'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M219.264 314.309C219.264 314.297 219.264 314.286 219.23 313.129C219.196 311.972 219.128 309.669 219.058 307.296'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M207.854 307.505L207.693 310.42'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M191.275 295.336C191.258 295.32 191.242 295.305 190.719 294.926C190.195 294.548 189.165 293.808 187.479 292.709'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M196.931 290.121C196.886 290.131 196.841 290.142 197.054 289.407C197.268 288.673 197.742 287.193 198.053 286.087C198.365 284.98 198.499 284.291 198.638 283.366'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M191.244 281.881C190.802 281.623 190.36 281.364 189.867 281.153C189.375 280.942 188.845 280.786 188.277 280.625'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M191.661 265.562L191.627 265.642'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M206.726 276.87L206.772 276.434'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M209.248 265.33C209.268 265.365 209.288 265.401 210.117 265.852C210.946 266.303 212.584 267.168 214.27 268.059'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M223.565 269.157C223.549 269.052 223.534 268.947 223.456 268.018C223.378 267.089 223.238 265.34 223.094 263.538'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M214.808 289.243L218.167 287.051'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M211.545 297.175L212.157 298.1'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M227.717 310.301L231.347 310.537'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M236.799 303.86L236.897 301.437'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M256.102 311.291C256.035 311.13 255.967 310.97 255.854 310.402C255.742 309.835 255.587 308.865 255.427 307.867'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M240.859 293.082C240.734 292.928 240.609 292.774 239.962 292.197C239.315 291.62 238.15 290.624 236.95 289.598'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M234.134 281.538L236.748 280.599'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M245.715 286.711C245.715 286.683 245.715 286.656 245.805 286.329C245.895 286.003 246.075 285.378 246.698 283.988'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M258.998 291.2C260.018 291.638 261.038 292.076 262.023 292.499C263.007 292.922 263.924 293.316 264.869 293.723'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M261.94 302.176C261.98 302.228 262.02 302.28 262.218 302.507C262.416 302.734 262.772 303.134 264.438 303.952'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M256.804 300.161L256.714 300.193'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M259.066 286.342C259.066 286.331 259.066 286.32 259.329 285.662C259.593 285.005 260.12 283.701 260.809 281.821'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M266.819 284.722C267.022 284.496 267.627 283.774 268.503 282.597C268.879 282.026 269.113 281.509 269.266 280.953C269.419 280.397 269.482 279.818 269.547 278.236'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M256.28 276.111C256.235 276.067 256.19 276.023 255.406 276.177C254.621 276.332 253.099 276.687 250.844 277.076'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M242.095 273.396C242.095 273.215 242.095 273.034 242.059 272.434C242.024 271.834 241.952 270.82 241.432 268.831'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M230.534 272.744C230.405 272.996 230.276 273.249 230.028 273.675C229.78 274.102 229.416 274.695 229.041 275.307'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M236.895 261.877C236.917 261.877 236.939 261.877 238.414 261.522C239.888 261.168 242.813 260.46 245.827 259.73'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M266.257 264.909C266.246 264.898 266.234 264.887 265.619 264.415C265.004 263.943 263.785 263.01 262.586 262.194C261.387 261.378 260.245 260.706 258.502 259.775'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M259.266 270.21C259.861 270.249 260.457 270.288 262.141 270.479C263.826 270.67 266.581 271.011 269.419 271.362'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M254.078 253.342C254.078 253.298 254.078 253.253 254.073 252.712C254.068 252.17 254.057 251.133 254.046 250.064'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M231.334 251.917C231.167 251.835 231 251.753 230.045 251.217C229.09 250.681 227.352 249.693 226.236 249.003C225.12 248.312 224.679 247.949 224.225 247.576'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M214.004 241.795C214.154 241.565 214.304 241.334 214.613 240.707C214.921 240.08 215.384 239.064 215.907 237.676'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M186.263 222.789C186.057 223.036 185.85 223.283 185.437 223.783C185.024 224.283 184.41 225.027 183.649 226.061'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M191.132 235.686C191.074 235.708 191.015 235.73 190.059 236.362C189.104 236.993 187.252 238.232 185.345 239.508'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M191.002 249.749L190.952 249.699'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M206.368 237.225C206.358 237.11 206.348 236.995 206.327 236.465C206.306 235.935 206.274 234.994 206.242 234.025'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M176.52 215.358L183.704 215.33'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M196.654 217.752C196.654 217.724 196.654 217.696 196.642 217.332C196.63 216.968 196.606 216.269 196.546 215.311'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M190.782 215.709L190.79 215.745'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M199.784 203.702C199.784 203.669 199.784 203.636 200.156 203.122C200.527 202.609 201.27 201.616 202.036 200.592'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M187.265 190.762L186.702 190.688'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M201.977 184.923L203.699 185.252'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M188.04 163.822L188.552 165.273'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M173.532 154.084L172.39 153.378'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M189.405 152.843C189.711 152.583 190.017 152.322 190.843 151.787C191.668 151.252 193.004 150.45 194.381 149.623'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M183.546 144.796C182.936 144.733 182.325 144.671 181.687 144.588C181.048 144.504 180.399 144.401 179.731 144.295'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M190.26 139.906C190.326 139.736 190.392 139.565 190.559 139.056C190.725 138.546 190.991 137.702 191.31 136.614'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M185.322 126.361C185.347 126.125 185.372 125.889 185.429 125.342C185.487 124.795 185.576 123.944 185.669 123.067'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M168.954 115.939C168.954 115.912 168.954 115.884 169.106 115.442C169.259 115 169.563 114.145 169.876 113.264'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M169.812 104.522V104.625'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M193.863 124.86L198.545 124.081'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M176.837 127.412L176.884 127.46'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M208.158 137.763C209.09 137.773 210.021 137.783 210.802 137.773C211.583 137.763 212.185 137.733 212.806 137.703'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M208.355 129.565L208.055 130'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M199.483 142.456L199.373 142.54'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M206.249 156.25C206.251 156.233 206.253 156.216 206.496 156.094C206.739 155.972 207.223 155.746 207.722 155.513'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M221.37 154.06C221.467 154.151 221.563 154.242 222.298 154.879C223.032 155.516 224.401 156.696 225.454 157.529C226.506 158.361 227.201 158.81 228.613 159.558'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M222.796 143.075C222.305 143.506 221.815 143.937 221.004 144.594C220.192 145.25 219.075 146.12 217.924 147.016'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M209.496 166.284C209.267 166.37 209.038 166.456 208.493 166.782C207.948 167.108 207.094 167.671 206.214 168.252'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M207.805 174.446L207.112 174.797'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M213.523 194.424C213.523 194.605 213.523 194.785 213.542 195.364C213.56 195.942 213.597 196.914 213.719 198.061'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M208.368 205.842C210.236 206.258 212.104 206.674 213.482 206.998C214.86 207.321 215.691 207.538 216.548 207.762'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M215.719 214.615L216.092 220.689'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M225.859 233.449L228.3 232.377'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M216.405 231.443L217.144 231.544'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M243.387 237.582C243.449 237.739 243.51 237.897 243.771 238.445C244.031 238.994 244.49 239.93 245.208 241.166'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M237.717 227.3L235.717 229.509'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M238.253 241.154L237.913 240.917'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M261.518 239.791C261.722 239.714 261.927 239.637 262.52 239.525C263.113 239.412 264.088 239.266 265.262 239.116'
        stroke='#EBEEFF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M241.66 249.448L240.416 249.735'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M252.227 234.916C252.776 234.421 253.325 233.926 253.93 233.348C254.534 232.77 255.176 232.123 255.839 231.456'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M260.741 222.627C260.732 222.609 260.723 222.591 260.564 222.025C260.405 221.458 260.096 220.344 259.917 219.319C259.738 218.294 259.698 217.391 259.656 216.461'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M269.412 227.592L269.444 228.293'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M273.712 250.328L273.704 250.652'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M262.359 252.694C262.314 252.54 262.269 252.387 262.075 251.848C261.882 251.309 261.541 250.389 261.058 249.242'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M272.601 258.712L270.237 257.262'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M255.677 242.87L254.834 243.012'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M260.837 212.591C261.749 211.699 262.661 210.807 263.384 209.934C264.106 209.062 264.611 208.237 265.289 206.467'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M253.325 207.464C252.958 207.775 252.591 208.086 251.554 208.912C250.517 209.737 248.822 211.067 247.075 212.438'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M241.206 215.773C241.168 215.8 241.13 215.827 240.71 215.143C240.29 214.459 239.487 213.063 238.661 211.625'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M232.384 204.877L230.343 204.605'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M223.154 202.778L222.543 205.686'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M226.611 210.559C226.358 210.78 226.105 211.001 225.611 211.508C225.118 212.014 224.391 212.798 223.136 214.035'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M245.655 202.981C245.711 202.958 245.767 202.936 246.296 202.757C246.825 202.579 247.826 202.245 249.344 201.821'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M258.931 205.016V205.049'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M254.988 197.242C254.977 197.22 254.965 197.197 254.892 196.428C254.819 195.658 254.684 194.142 254.532 193.073C254.38 192.004 254.215 191.428 253.916 190.602'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M241.7 187.431C241.165 187.326 240.63 187.221 239.627 187.059C238.623 186.897 237.167 186.681 235.568 186.458'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M230.825 191.777L226.62 194.128'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M235.132 197.522C235.132 197.485 235.132 197.447 235.122 196.836C235.113 196.225 235.094 195.041 235.061 193.784'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M224.105 185.401C224.03 185.165 223.955 184.929 223.697 184.01C223.44 183.092 223.002 181.498 222.46 179.265'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M239.313 178.701L242.957 179.45'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M241.175 170.959C241.163 170.904 241.152 170.848 241.06 169.88C240.968 168.912 240.796 167.032 240.618 165.096'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M233.723 175.537C233.723 175.548 233.723 175.558 233.155 176.036C232.587 176.513 231.451 177.456 230.206 178.515'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M233.324 166.796V166.848'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M233.603 152.785H233.654'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M236.783 158.517L242.228 158.795'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M215.941 174.193L215.891 174.225'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M250.871 217.363L250.821 217.359'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M134.04 184.54L131.74 185.804'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M110.034 181.449L112.124 184.031'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M130.17 242.065C130.163 242.018 130.155 241.972 130.121 241.292C130.088 240.612 130.028 239.301 129.967 237.95'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M100.467 233.88C100.443 233.88 100.42 233.88 98.9012 234.333C97.3823 234.785 94.3683 235.69 91.2629 236.623'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M61.7356 265.706C61.9988 266.343 62.2619 266.979 62.8366 267.976C63.4112 268.974 64.2894 270.312 65.0725 271.362C65.8557 272.412 66.5172 273.133 67.1988 273.876'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M92.2792 280.877C92.2681 280.699 92.257 280.522 92.2045 279.979C92.1519 279.435 92.0583 278.531 91.9988 277.567'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M151.847 281.55L145.438 278.12'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M146.769 212.863C146.582 212.54 146.395 212.217 146.033 211.675C145.672 211.133 145.142 210.381 144.595 209.607'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M93.581 211.226L89.7732 210.346'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M44.7186 207.641C44.2144 207.751 43.7102 207.862 43.1768 208.074C42.6434 208.287 42.096 208.597 41.532 208.917'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.0525 266.256L29.0929 266.381'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M117.27 272.077V271.99'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M166.586 245.428C166.619 245.305 166.652 245.182 166.699 244.787C166.746 244.393 166.805 243.731 166.866 243.049'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M155.035 231.009C155.03 231.006 155.024 231.003 154.636 230.923C154.247 230.843 153.476 230.686 152 230.492'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M110.944 216.945L111.73 216.526'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M27.7816 249.013C27.6929 248.95 27.6043 248.886 27.1558 248.604C26.7073 248.322 25.9018 247.824 25.0718 247.311'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M38.2141 289.179C37.9886 289.704 37.7631 290.23 37.5572 290.731C37.3513 291.232 37.1718 291.693 36.9868 292.167'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M34.8601 312.435C34.8507 312.489 34.8413 312.544 34.788 313.24C34.7346 313.937 34.6377 315.272 34.6033 316.929'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M163.351 306.377C163.421 306.321 163.491 306.266 164.128 306.027C164.764 305.788 165.964 305.368 167.2 304.935'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M173.075 288.364C173.065 288.179 173.054 287.994 172.913 287.04C172.772 286.087 172.5 284.37 172.22 282.602'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M164.795 257.512C164.73 257.466 164.665 257.419 164.36 257.353C164.055 257.287 163.511 257.203 162.951 257.116'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M180.411 259.731C180.184 259.91 179.957 260.089 179.553 260.45C179.149 260.812 178.575 261.35 177.983 261.905'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M139.306 257.89C139.306 257.899 139.306 257.908 138.898 258.297C138.489 258.686 137.672 259.455 136.83 260.247'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M123.074 297.945C122.891 298.179 122.708 298.414 121.963 299.279C121.218 300.144 119.917 301.634 118.576 303.168'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M91.6214 313.843L90.2307 313.032'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M66.4737 302.61C66.1984 302.513 65.923 302.417 65.1881 302.308C64.4531 302.199 63.2669 302.08 62.373 302.033C61.4791 301.985 60.9134 302.012 60.3306 302.039'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M22.5226 302.868H22.4355'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M17.6335 285.228L19.5576 285.455'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M14.4829 267.708C14.4962 267.465 14.5095 267.222 14.5842 266.003C14.6589 264.785 14.7947 262.599 14.9345 260.346'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M5.09908 259.513L4.9165 259.456'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M14.936 226.435C16.6929 226.918 18.4498 227.401 19.6706 227.711C20.8915 228.02 21.5231 228.142 22.1739 228.267'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M26.623 204.387L26.7541 205.153'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M40.2742 228.542C41.144 228.733 42.0139 228.924 42.8886 229.094C43.7633 229.265 44.6165 229.409 45.4956 229.558'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M63.603 241.479C63.6468 241.172 63.6906 240.865 63.7846 239.719C63.8786 238.574 64.0215 236.6 64.1688 234.566'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M43.4794 248.304C43.4794 248.424 43.4794 248.545 43.3132 249.134C43.147 249.722 42.8145 250.774 42.4653 252.006'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M86.1921 255.604L86.35 254.614'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M106.238 260.598C106.246 260.598 106.255 260.598 106.518 260.287C106.782 259.976 107.299 259.355 107.831 258.715'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M113.109 249.177L113.181 248.062'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M127.31 223.167L125.719 223.137'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M124.23 208.26L123.656 207.649'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M136.028 202.86C136.134 202.683 136.24 202.505 136.483 202.091C136.725 201.677 137.102 201.032 137.583 199.898'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M114.796 193.21C114.663 193.198 114.529 193.186 113.854 193.166C113.179 193.146 111.967 193.119 110.718 193.091'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M83.6764 185.309C83.5728 185.266 83.4692 185.222 83.1194 185.053C82.7696 184.884 82.1768 184.591 81.4888 184.085'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M89.0417 174.728L89.1862 175.682'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M55.2104 187.324L53.907 188.25'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M45.1717 196.55L44.7686 196.506'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M34.7842 190.047L35.1688 190.201'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M72.343 201.51C73.8356 201.309 75.3282 201.108 76.3597 200.941C77.3913 200.775 77.9165 200.649 78.4576 200.52'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M70.5175 188.289C70.4898 188.27 70.4621 188.251 70.1973 187.944C69.9325 187.637 69.4314 187.042 68.8967 186.414'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M63.5946 215.375C62.8134 215.721 62.0322 216.068 61.4367 216.37C60.8412 216.672 60.455 216.92 60.0571 217.175'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M36.1111 218.194L35.8608 218.774'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M73.51 225.059C73.7311 225.045 73.9521 225.032 74.6076 225.116C75.2631 225.2 76.3462 225.382 77.4773 225.577'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M59.2296 250.798L56.7532 252.64'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M47.5538 266.63C47.5626 266.825 47.5715 267.019 47.5652 267.491C47.559 267.962 47.5374 268.705 47.5151 269.469'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M45.9727 297.829L48.1351 297.177'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M78.1693 312.898L78.0518 312.295'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M91.8557 295.813L92.4872 295.598'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M74.6626 286.434C74.6349 286.434 74.6072 286.434 74.2939 286.418C73.9806 286.403 73.3825 286.372 72.7664 286.34'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M80.5648 269.851L80.3633 268.853'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M73.7371 252.044L73.3862 249.688'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M97.1223 248.672C97.1223 248.681 97.1223 248.69 97.2354 248.926C97.3485 249.163 97.5746 249.626 97.8076 250.103'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M105.462 280.792C105.527 280.857 105.593 280.923 105.924 281.132C106.255 281.342 106.849 281.694 107.787 282.192'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M133.192 286.55L132.402 285.181'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M94.2981 266.78C94.5784 266.811 94.8588 266.842 95.3484 266.886C95.838 266.93 96.5283 266.986 97.2396 267.044'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M108.782 294.85L108.697 295.263'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M103.757 316.077L104.773 314.335'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M137.685 304.82C137.711 304.673 137.737 304.525 137.876 304.209C138.016 303.892 138.267 303.411 138.527 302.916'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M154.656 300.283L151.848 298.059'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M123.019 283.108L124.076 281.676'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M123.386 250.394L124.85 254.135'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M167.974 267.693C167.925 267.646 167.876 267.599 167.429 267.566C166.982 267.534 166.138 267.518 165.27 267.501'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M137.735 268.962C137.539 269.007 137.343 269.053 136.701 269.134C136.059 269.215 134.977 269.33 133.861 269.449'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M152.072 245.804C151.954 245.745 151.837 245.686 151.237 245.364C150.637 245.043 149.558 244.46 148.447 243.859'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M157.592 210.793C157.927 211.312 158.262 211.83 158.683 212.434C159.104 213.038 159.601 213.711 160.112 214.404'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M153.541 198.433C153.516 198.461 153.49 198.489 153.167 198.686C152.843 198.883 152.222 199.248 151.224 199.906'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M169.807 226.78L168.633 226.889'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M139.881 224.046C139.782 224.057 139.683 224.067 139.179 224.059C138.674 224.05 137.766 224.023 136.83 223.994'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M95.4448 197.74H95.3994'
        stroke='#ABB8FF'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M154.176 265.154C154.334 265.525 154.492 265.896 154.698 266.286C154.904 266.676 155.153 267.074 155.41 267.484'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M181.541 302.651C181.411 302.698 181.281 302.746 180.731 302.898C180.182 303.051 179.217 303.308 178.222 303.573'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M165.021 292.455C164.942 292.433 164.864 292.41 164.431 292.381C163.998 292.353 163.213 292.319 161.886 292.439'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M102.779 305.09L104.944 305.202'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M74.2425 297.411C74.2425 297.375 74.2425 297.34 74.0663 297.152C73.89 296.964 73.5375 296.625 73.1743 296.275'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M52.5017 285.053L52.4983 284.094'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.2604 277.909C29.2604 277.914 29.2604 277.918 29.0346 277.955C28.8089 277.992 28.3573 278.062 27.1836 278.169'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.285 293.267L28.1597 294.165'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M14.8738 297.209L12.7466 296.017'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M8.71382 277.798L8.6416 277.22'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M24.178 236.864L25.824 235.974'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M11.8872 239.594L12.4264 240.568'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M114.882 231.295L114.866 232.612'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M98.2939 224.278L95.104 224.736'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M58.0486 201.375L58.2194 201.603'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M22.9109 215.388L27.0864 215.457'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M57.8889 223.648L58.0014 224.026'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M52.7618 239.026C52.6654 239.026 52.569 239.026 52.1725 239.03C51.776 239.034 51.0824 239.042 50.3677 239.05'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M76.3562 238.497L76.6904 238.537'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M98.9343 184.633C98.9343 184.642 98.9343 184.651 98.4816 184.79C98.029 184.929 97.1237 185.199 96.0684 185.563'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M109.098 202.083L108.413 202.806'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M123.876 183.969L124.935 186.643'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M175.961 241.778L175.981 242.593'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M152.533 221.115L151.102 221.078'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M141.239 239.016C140.062 239.914 138.886 240.812 138.114 241.494C137.343 242.177 137.013 242.616 136.673 243.069'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M183.251 271.011C183.111 270.997 182.971 270.982 182.334 271.007C181.696 271.031 180.565 271.094 179.399 271.159'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M148.939 256.178L149.649 255.896'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M33.7734 258.3H35.658'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M12.677 248.654L12.3276 248.955'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M19.519 312.216C19.519 312.316 19.519 312.416 19.6473 312.872C19.7756 313.327 20.0321 314.134 20.879 315.646'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M85.6356 278.825C85.1359 279.483 84.6361 280.142 84.1482 280.693C83.6603 281.245 83.1993 281.671 82.7244 282.109'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M60.1294 290.758C60.12 290.758 60.1106 290.758 59.9763 290.968C59.842 291.177 59.5832 291.596 59.1553 292.409'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M121.647 261.745L121.656 261.742'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M77.8049 210.823L77.7192 211.281'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M125.807 197.479L124.833 198.149'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M142.128 190.211C142.057 190.085 141.987 189.959 141.809 189.565C141.631 189.17 141.348 188.511 141.056 187.832'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M170.109 216.933V217.225'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M143.275 289.385L142.03 291.996'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M83.7798 305.458L85.2713 304.766'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M44.4552 305.513C44.4087 305.513 44.3622 305.513 44.0368 305.402C43.7114 305.292 43.1086 305.071 42.4875 304.843'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M53.2577 212.662C53.2577 212.644 53.2577 212.625 53.2319 212.29C53.2062 211.956 53.1546 211.307 53.1016 210.638'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M34.5809 198.432C34.5715 198.432 34.5621 198.432 34.8199 198.872C35.0776 199.311 35.6029 200.191 36.2699 201.256'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M86.6393 191.75L86.554 191.708'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M109.635 223.08L109.866 223.819'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M107.043 240.836C106.946 240.811 106.848 240.787 106.029 240.837C105.211 240.886 103.674 241.011 101.484 241.252'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M130.872 211.841C130.872 211.832 130.872 211.823 131.196 212.162C131.52 212.501 132.168 213.189 133.044 214.076'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M118.458 289.92C118.435 289.92 118.411 289.92 117.717 289.838C117.023 289.755 115.658 289.59 114.252 289.42'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M152.316 307.179L154.442 309.333'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M85.0656 244.54C85.0468 244.54 85.0279 244.54 84.9484 244.186C84.8689 243.831 84.7293 243.123 84.5854 242.393'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M53.9026 231.717C54.1663 231.6 54.43 231.483 54.7895 231.274C55.1489 231.064 55.596 230.766 56.0566 230.458'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M38.2531 235.55L37.0879 237.513'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M131.835 294.018L130.778 293.836'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M124.934 268.87C124.917 268.959 124.9 269.047 125.023 269.414C125.147 269.78 125.411 270.421 125.683 271.081'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M166.526 277.486L163.544 278.502'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M183.085 250.917C183.057 250.908 183.029 250.898 182.381 250.894C181.733 250.889 180.464 250.889 179.158 250.889'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M162.859 229.851C162.813 229.915 162.766 229.979 162.575 230.474C162.384 230.968 162.05 231.891 161.662 233.408'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M103.247 206.562C103.209 206.792 103.172 207.021 103.23 207.377C103.289 207.732 103.445 208.207 103.606 208.696'
        stroke='#FF9898'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M125.15 306.397L125.269 310.388'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M174.605 310.019C174.605 310.037 174.605 310.055 174.647 310.452C174.689 310.849 174.773 311.623 174.86 312.876'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M172.419 295.986L172.402 295.902'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M157.874 286.218C156.751 286.378 155.627 286.537 154.762 286.652C153.897 286.767 153.324 286.831 152.733 286.898'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M181.076 284.959C181.027 284.824 180.978 284.689 180.761 284.236C180.545 283.783 180.163 283.015 179.696 282.116'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M148.276 266.493C148.24 266.54 148.204 266.588 147.839 267.022C147.474 267.456 146.781 268.276 146.066 269.12'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M138.976 276.803L137.426 276.874'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M132.849 252.058L135.939 252.024'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M138.96 231.699H141.456'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M155.497 239.264C155.497 239.273 155.497 239.282 155.762 239.453C156.028 239.624 156.56 239.957 157.107 240.3'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M174.152 233.314L170.977 232.879'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M155.689 203.669L155.3 204.438'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M143.617 201.508L144.337 202.036'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M138.627 218.63L139.905 217.246'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M123.216 215.583C121.909 215.955 120.601 216.328 119.721 216.642C118.84 216.955 118.426 217.198 118 217.448'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M114.172 206.427C114.163 206.427 114.153 206.427 113.862 206.248C113.572 206.069 113 205.712 112.48 205.469C111.96 205.226 111.51 205.11 111.046 204.99'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M122.553 192.055L122.009 192.135'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M102.77 188.816V192.379'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M101.177 176.938L97.8647 178.041'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M77.1589 178.778L75.5667 180.573'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M61.4038 193.877C61.8155 193.932 62.2271 193.986 62.9913 194.161C63.7555 194.336 64.8597 194.629 65.9973 194.932'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M65.2596 205.195L65.0884 207.279'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M44.2585 220.729C44.3134 220.729 44.3682 220.729 44.7979 220.723C45.2276 220.717 46.0304 220.704 46.8575 220.692'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M31.3874 224.963C31.3398 225.891 31.2922 226.82 31.2554 227.76C31.2187 228.699 31.1943 229.622 31.1692 230.572'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M19.6021 219.938L20.6938 221.191'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M18.9371 241.662C18.9238 241.816 18.9105 241.97 18.9095 242.426C18.9085 242.882 18.9201 243.635 18.9321 244.412'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M33.1135 244.812C33.1418 244.803 33.17 244.794 33.4214 244.853C33.6729 244.912 34.1466 245.04 35.0225 245.376'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M23.8598 256.5C23.8504 256.537 23.841 256.573 23.4683 257.23C23.0955 257.886 22.3597 259.162 21.1584 261.666'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M13.4199 275.711L15.2171 275.603'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M37.114 275.065C37.2691 275.256 37.4243 275.446 37.6618 275.767C37.8994 276.088 38.2146 276.533 38.5394 276.992'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M9.60366 284.353C9.58704 284.362 9.57042 284.372 9.19924 284.616C8.82805 284.861 8.10281 285.34 7.13062 286.114'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.5156 283.368C30.0109 283.864 30.5063 284.361 31.0828 284.876C31.6593 285.392 32.302 285.911 32.9641 286.447'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M34.1699 302.205C33.5787 302.535 32.9876 302.864 32.2068 303.559C31.4261 304.253 30.4737 305.303 29.4102 306.513'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M21.9524 293.906H21.8379'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M52.7415 307.664C52.7321 307.627 52.7227 307.59 52.5029 307.095C52.2831 306.6 51.8531 305.649 51.4102 304.669'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M46.2854 290.685L46.2563 290.666'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M44.2026 282.157C44.2542 282.105 44.3057 282.053 44.8746 281.608C45.4436 281.162 46.5284 280.325 48.2438 278.638'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M42.8311 313.816C42.6926 314.01 42.5541 314.204 42.1858 314.89C41.8174 315.575 41.2235 316.747 40.6116 317.953'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M107.832 273.472C107.262 273.4 106.692 273.329 106.05 273.297C105.408 273.266 104.711 273.276 103.993 273.287'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M93.1455 258.071L93.7031 258.758'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M87.0705 226.536C87.0428 226.577 87.0151 226.618 86.792 226.976C86.5688 227.335 86.1511 228.011 85.6367 228.883'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M87.4822 216.451C87.3858 216.425 87.2894 216.4 86.3239 216.428C85.3584 216.456 83.5268 216.538 81.4465 216.666'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M86.2754 201.152L91.067 203.439'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M67.1958 224.5L67.2328 225.55'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M67.7652 249.81C67.7397 249.844 67.7143 249.879 67.5468 250.169C67.3793 250.458 67.0705 251.001 66.7524 251.56'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M51.2534 247.036L49.5879 248.975'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M52.1106 259.284C52.1106 259.293 52.1106 259.301 52.3489 259.406C52.5873 259.511 53.0639 259.712 53.5551 259.919'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M57.8374 270.352C57.8003 270.407 57.7631 270.462 57.6634 270.868C57.5637 271.274 57.4024 272.03 57.2363 273.443'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M72.8673 261.126C72.8485 261.134 72.8296 261.143 72.3587 261.166C71.8877 261.188 70.9652 261.223 70.1496 261.217C69.3339 261.212 68.653 261.163 67.9514 261.114'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M105.851 252.113L103.147 253.389'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M118.327 240.964L121.426 239.901'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M126.629 229.213L124.786 229.951'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M100.925 285.228L100.746 289.565'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M94.5288 302.701L95.0512 304.538'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M83.2178 290.049L82.2087 292.124'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M63.9351 282.036C63.9799 281.936 64.0248 281.837 64.2202 281.483C64.4157 281.129 64.7603 280.524 65.1153 279.9'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M65.2097 310.852C65.2186 310.852 65.2274 310.852 65.1605 311.086C65.0936 311.321 64.9507 311.79 64.8607 312.278C64.7707 312.766 64.738 313.259 64.7043 313.766'
        stroke='#9BE2C0'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M75.0986 275.567L76.7547 275.502'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M70.1355 239.766C70.2009 239.831 70.2663 239.897 70.8731 240.483C71.4799 241.07 72.6262 242.176 73.8073 243.315'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M50.4653 198.435L51.5231 200.615'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M44.2798 187.533H44.3252'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M38.6105 264.57L37.8262 265.684'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M22.2847 272.522L23.0019 271.688'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M8.53928 264.246C8.5354 264.246 8.53152 264.246 8.64033 264.621C8.74915 264.996 8.97076 265.747 9.414 266.915'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M12.2343 254.7L12.2258 254.838'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M12.0885 229.612L11.8987 231.48'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M73.5603 304.497L74.5748 304.875'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M115.028 278.39C115.028 278.399 115.028 278.407 114.917 278.671C114.806 278.935 114.584 279.454 114.301 280.199'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M113.013 263.933C113.652 263.827 114.291 263.721 114.981 263.591C115.67 263.461 116.392 263.311 117.135 263.155'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M171.629 252.59C171.638 252.59 171.647 252.591 171.789 252.871C171.931 253.151 172.205 253.71 172.875 254.893'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M157.555 248.549C157.546 248.549 157.536 248.549 157.043 248.773C156.549 248.997 155.571 249.445 154.563 249.907'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M154.209 273.363L154.391 274.311'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M144.455 301.776C144.434 302.073 144.413 302.371 144.394 302.902C144.375 303.433 144.358 304.188 144.341 304.966'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M113.611 305.178V306.804'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M96.8309 311.173L96.7332 311.213'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M65.0764 295.4C65.0764 295.391 65.0764 295.381 64.5409 295.559C64.0054 295.736 62.9345 296.101 61.8311 296.476'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M70.2239 267.263C70.6882 267.123 71.1525 266.984 71.608 266.866C72.0635 266.748 72.4962 266.656 73.6052 266.291'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M89.6533 269.091L90.4041 269.828'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M82.8903 263.76L82.7441 263.104'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M76.6602 232.605C76.6602 232.614 76.6602 232.623 77.0674 232.623C77.4746 232.623 78.289 232.613 79.1282 232.604'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M100.511 213.698L100.457 213.998'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M70.8909 213.413C70.8909 213.44 70.8909 213.467 70.9859 213.831C71.0809 214.195 71.2709 214.895 71.9385 216.339'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M104.914 229.014L108.671 231.114'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M121.445 176.676L120.724 177.556'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M118.011 198.636C117.983 198.747 117.955 198.858 117.931 199.147C117.907 199.436 117.888 199.899 117.869 200.376'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M157.993 223.006L160.639 222.054'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M175.983 224.06L176.055 224.135'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M161.799 199.521C161.862 200.084 161.926 200.647 161.981 201.241C162.037 201.836 162.084 202.445 162.132 203.072'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M143.716 169.643H143.886'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M76.4277 189.248L76.5772 190.166'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M173.756 273.438C173.756 273.447 173.756 273.456 173.851 273.719C173.945 273.981 174.134 274.497 174.329 275.029'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M180.761 294.667L180.716 294.709'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <path
        d='M29.3628 239.437C28.9229 239.792 28.483 240.147 27.9076 240.567C27.3322 240.987 26.6347 241.462 25.916 241.95'
        stroke='#DFF7EB'
        stroke-width='4.20507'
        stroke-linecap='round'
      />
      <circle
        cx='268.42'
        cy='137.42'
        r='131.42'
        fill='#E6F3FA'
        stroke='#CDEAFA'
        stroke-width='12'
      />
      <mask
        id='mask0_517_8301'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='143'
        y='12'
        width='251'
        height='252'
      >
        <circle cx='268.42' cy='138.104' r='125.42' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_517_8301)'>
        <path
          className='animated-microbe'
          d='M324.653 194.884C323.775 194.741 322.824 194.812 321.945 195.027C321.067 195.242 320.189 195.672 319.457 196.245C318.725 196.818 318.14 197.535 317.701 198.395C317.261 199.255 316.969 200.115 316.895 201.046C316.895 203.482 317.847 205.847 319.603 207.566C321.36 209.286 323.629 210.289 325.971 210.289C330.362 210.504 333.509 208.211 333.655 204.629C333.655 202.121 332.631 199.828 330.947 197.965C329.264 196.102 327.068 195.027 324.653 194.741L324.653 194.884Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M117.767 167.914C116.148 168.544 114.484 169.049 112.792 169.427C99.7102 170.983 86.6202 172.499 73.522 173.975C72.3712 174.228 71.1802 174.188 70.0612 173.857C68.7779 173.259 67.0489 172.225 66.8486 171.106C66.7866 170.319 66.8974 169.525 67.1732 168.778C67.449 168.031 67.8833 167.349 68.4462 166.779C69.7977 165.755 71.4182 165.149 73.1001 165.038C86.1006 163.499 99.2604 161.987 112.348 160.486C113.114 160.403 114.04 160.03 114.656 160.308C116.296 161.128 118.498 161.832 118.996 163.176C119.494 164.52 118.198 166.49 117.767 167.914Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M120.684 159.081C119.707 160.241 117.378 161.84 117.482 163.235C117.725 164.177 118.217 165.039 118.912 165.739C119.607 166.439 120.482 166.954 121.453 167.234C127.642 167.778 133.901 167.657 140.134 167.652C141.308 167.54 142.448 167.188 143.475 166.619C145.726 165.561 147.623 164.062 146.866 161.378C146.109 158.694 143.73 158.489 141.219 158.724C137.936 159.029 134.74 159.349 131.496 159.424C128.252 159.499 124.988 159.213 120.684 159.081Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M41.3981 166.281C40.4239 167.472 38.1024 169.096 38.2059 170.553C38.4468 171.539 38.9367 172.447 39.6291 173.19C40.3214 173.933 41.1929 174.486 42.1602 174.796C48.3265 175.479 54.5637 175.47 60.7735 175.582C61.9436 175.487 63.0795 175.141 64.1037 174.568C66.3465 173.506 68.2376 171.979 67.4851 169.166C66.7325 166.354 64.3618 166.096 61.8596 166.293C58.5885 166.55 55.4036 166.824 52.1712 166.842C48.9388 166.859 45.6863 166.499 41.3981 166.281Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M233.834 271.882C233.634 272.186 233.286 272.583 233.086 272.888C232.512 273.695 232.031 274.648 231.23 275.402C228.572 277.718 226.515 280.55 224.151 283.17C223.443 284.07 222.521 284.784 221.613 285.512C221.333 285.684 220.758 285.538 220.291 285.419C220.371 285.089 220.491 284.639 220.571 284.295C222.455 282.138 224.365 279.875 226.368 277.757C227.543 276.5 228.946 275.296 230.108 274.039C230.615 273.457 231.016 272.835 231.416 272.226L231.123 271.922C230.468 272.12 229.8 272.306 229.266 272.531C227.37 273.258 225.567 274.118 224.284 275.825C223.029 277.413 221.279 278.538 219.824 279.954C219.343 280.431 218.915 281.158 218.314 281.608C217.994 281.886 217.313 281.714 216.792 281.833C216.899 281.383 216.845 280.656 217.152 280.378C218.461 279.041 220.011 277.758 221.293 276.527C222.241 275.693 223.002 274.568 224.057 273.761C225.513 272.808 226.942 271.975 228.465 271.287C229.293 270.903 230.121 270.506 230.842 270.096C231.016 269.897 231.189 269.699 231.243 269.487C231.296 269.262 231.35 269.037 231.416 268.812C231.149 267.912 231.123 267.079 231.23 266.152C231.336 265.226 231.684 264.366 232.338 263.691C236.532 257.71 239.31 251.014 242.609 244.702C243.343 243.22 244.225 241.658 245.801 240.732C247.083 239.978 248.472 239.845 249.727 240.626C250.355 241.023 250.849 241.499 251.17 242.174C251.49 242.849 251.544 243.577 251.49 244.278C251.21 245.403 250.929 246.515 250.649 247.639C248.352 252.43 246.041 257.207 243.517 261.931C242.355 264.141 240.752 266.126 239.35 268.283C239.096 268.812 238.642 269.183 238.175 269.54C236.746 270.374 236.144 271.776 235.891 273.258C235.196 277.493 232.912 280.735 229.333 283.302C229.159 283.501 228.879 283.659 228.612 283.725C228.612 283.725 228.385 283.673 228.265 283.646C228.144 283.62 228.037 283.593 227.917 283.567C227.744 283.289 227.797 283.064 227.85 282.839C227.904 282.614 228.078 282.415 228.358 282.257C230.482 281.119 231.59 279.134 232.926 277.202C234.034 275.693 234.261 273.841 234.221 272.054L233.874 271.975L233.754 271.948L233.834 271.882Z'
          fill='#FF9898'
        />
        <path
          className='animated-microbe'
          d='M241.835 11.1685C240.769 12.9132 239.678 16.7022 237.828 17.1982C236.524 17.2667 235.126 17.1554 233.89 16.5054C232.645 15.8554 231.58 15.1114 230.753 13.9909C227.224 6.37895 224.675 -1.6778 221.785 -9.54637C221.384 -11.1286 221.41 -12.728 221.708 -14.259C222.109 -17.663 223.26 -20.6992 227.079 -21.067C231.026 -21.4005 232.304 -18.3899 233.072 -15.0886C234.137 -10.8293 235.203 -6.56143 236.567 -2.362C237.931 1.84597 239.772 5.8914 241.835 11.1685Z'
          fill='#FF9898'
        />
        <path
          className='animated-microbe'
          d='M141.004 250.271C138.594 252.531 136.38 254.975 134.357 257.578C133.451 258.883 133.293 261.748 134.131 262.666C134.979 263.58 137.789 263.716 139.238 263.06C141.246 261.897 143.04 260.394 144.555 258.631C147.416 255.546 151.227 253.522 155.361 252.861C159.496 252.2 163.723 252.964 167.337 255.016C170.11 256.511 172.545 258.691 175.401 259.891C176.987 260.549 179.13 259.759 181.031 259.639C180.866 257.801 181.344 255.21 180.385 254.064C175.616 248.54 168.875 245.062 161.557 244.361C154.239 243.66 146.887 245.779 141.008 250.283L141.004 250.271Z'
          fill='#ABB8FF'
        />
        <path
          className='animated-microbe'
          d='M223.903 142.347C221.492 144.607 219.278 147.051 217.255 149.654C216.349 150.959 216.191 153.824 217.029 154.742C217.878 155.657 220.687 155.792 222.136 155.136C224.144 153.973 225.938 152.471 227.453 150.708C230.314 147.622 234.125 145.598 238.26 144.937C242.394 144.276 246.621 145.04 250.235 147.092C253.008 148.588 255.443 150.767 258.299 151.967C259.885 152.625 262.029 151.835 263.929 151.716C263.764 149.877 264.243 147.286 263.283 146.141C258.515 140.617 251.774 137.138 244.455 136.437C237.137 135.736 229.785 137.855 223.906 142.359L223.903 142.347Z'
          fill='#ABB8FF'
        />
        <path
          className='animated-microbe'
          d='M304.842 254.998C307.021 259.128 310.792 261.055 313.449 263.868C314.575 264.826 315.413 266.119 316.023 267.579C316.167 268.322 316.203 269.148 316.035 269.926C315.867 270.704 315.628 271.362 315.269 272.105C314.682 272.488 314.096 272.871 313.425 273.134C312.755 273.398 312.061 273.35 311.282 273.182C309.499 272.5 307.871 271.53 306.398 270.309C302.723 267.484 302.412 267.52 299.91 271.159C299.431 271.973 298.832 272.859 298.162 273.637C296.462 275.409 294.223 276.869 292.176 275.002C290.895 273.816 290.812 271.35 290.321 269.315C290.213 268.884 290.68 268.07 291.003 267.532C294.14 262.803 294.343 257.464 294.367 252.065C294.439 245.468 294.582 238.98 294.846 232.42C294.894 231.211 294.87 229.882 295.349 229.068C296.259 227.631 297.599 226.602 299.239 226.039C299.946 226.087 300.796 226.374 301.418 226.805C302.041 227.248 302.615 227.871 302.998 228.469C303.944 231.223 304.339 234.156 304.423 237.124C304.531 241.422 304.016 245.792 304.016 250.173C303.956 251.897 304.219 253.573 304.902 255.141L304.83 255.022L304.842 254.998Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M348.135 236.191C350.243 235.984 352.244 235.698 354.297 235.129C358.729 233.746 363.252 232.27 367.577 230.807C370.409 229.846 372.104 230.623 372.926 233.478C373.009 234.017 373.277 234.541 373.438 234.985C374.437 237.812 375.729 240.694 379.489 239.783C383.155 238.794 383.082 235.372 382.369 232.585C380.33 225.451 377.582 218.598 375.543 211.464C373.439 203.963 371.521 196.437 369.979 188.859C369.073 184.807 366.867 182.061 363.779 182.499C362.974 182.703 362.167 182.919 361.497 183.379C360.825 183.852 360.289 184.58 359.821 185.199C359.353 185.819 359.217 186.683 359.072 187.532C358.925 188.394 359.143 189.189 359.439 189.889C361.572 198.222 364.069 206.501 366.577 214.782C368.236 220.02 368.103 220.41 362.999 222.264C357.885 224.105 353.09 225.542 348.406 227.694C347.656 228.261 347.012 228.909 346.582 229.718C346.046 230.447 345.82 231.403 345.672 232.264C345.553 233.302 347.262 234.726 348.149 236.181L348.135 236.191Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M307.675 9.5009C307.499 8.6758 307.322 7.85086 306.77 7.10602C305.554 5.09116 303.802 3.50442 301.772 2.44841C299.682 1.48347 297.404 1.10781 295.212 1.49849C294.204 1.55727 293.186 1.9318 292.382 2.57449C291.578 3.21731 290.881 3.99459 290.473 5.02329C290.066 6.05194 289.9 7.10764 289.975 8.18997C289.994 8.46883 290.033 8.74332 290.091 9.01393C289.406 9.01567 288.681 9.09399 287.927 9.25545C285.735 9.64614 283.661 10.9529 282.315 12.7315C280.97 14.5101 280.443 16.8192 280.758 19.0268C280.935 19.8519 281.321 20.5541 281.873 21.2989C282.425 22.0438 283.094 22.6065 283.882 22.9871C284.67 23.3677 285.516 23.6573 286.39 23.7058C287.263 23.7542 288.18 23.6367 288.989 23.385L288.93 23.4756C291.24 22.9028 293.224 21.5368 294.462 19.6241C295.236 18.4288 295.762 17.0725 295.97 15.6843C296.337 15.8613 296.711 16.0214 297.094 16.1587C299.618 16.9523 302.266 16.8568 304.646 15.8767C305.348 15.4911 306.018 14.9548 306.506 14.3012C306.993 13.6477 307.374 12.8604 307.588 12.0302C307.803 11.1997 307.852 10.3261 307.675 9.5009Z'
          fill='#FF9898'
        />
        <path
          className='animated-microbe'
          d='M140.087 21.2823C139.209 21.139 138.257 21.2106 137.379 21.4256C136.501 21.6406 135.622 22.0705 134.891 22.6437C134.159 23.2169 133.573 23.9335 133.134 24.7933C132.695 25.6531 132.402 26.513 132.329 27.4445C132.329 29.8807 133.281 32.2452 135.037 33.9649C136.794 35.6846 139.062 36.6877 141.404 36.6877C145.795 36.9027 148.942 34.6098 149.089 31.0271C149.089 28.5193 148.064 26.2264 146.381 24.3634C144.698 22.5004 142.502 21.4256 140.087 21.139L140.087 21.2823Z'
          fill='#FF9898'
        />
        <path
          className='animated-microbe'
          d='M276.185 111.061C278.293 110.855 280.294 110.568 282.348 109.999C286.78 108.616 291.302 107.141 295.627 105.678C298.46 104.717 300.154 105.494 300.977 108.349C301.059 108.888 301.327 109.412 301.489 109.856C302.487 112.683 303.779 115.564 307.54 114.654C311.205 113.665 311.133 110.242 310.419 107.456C308.381 100.321 305.632 93.4689 303.594 86.3342C301.489 78.8341 299.571 71.3079 298.029 63.7294C297.124 59.6778 294.917 56.9315 291.829 57.3699C291.024 57.5739 290.217 57.7897 289.548 58.25C288.876 58.7221 288.339 59.4506 287.871 60.0701C287.403 60.6896 287.268 61.5532 287.122 62.4029C286.975 63.2644 287.193 64.0596 287.489 64.7598C289.623 73.093 292.119 81.3718 294.627 89.6527C296.286 94.891 296.153 95.2803 291.049 97.135C285.936 98.9758 281.14 100.413 276.456 102.565C275.706 103.132 275.062 103.78 274.633 104.589C274.096 105.317 273.87 106.274 273.723 107.135C273.603 108.172 275.312 109.597 276.199 111.052L276.185 111.061Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M340.333 45.1595C340.682 47.1606 341.202 49.0988 341.838 51.0907C343.522 55.4064 345.377 59.6592 347.286 63.7952C348.46 66.4599 347.939 68.2013 345.096 69.1544C344.585 69.3432 344.074 69.532 343.563 69.7208C340.899 70.8982 338.074 72.4257 339.391 76.0057C340.708 79.5857 343.972 79.2515 346.645 78.3613C353.461 75.844 360.142 72.6986 366.958 70.1813C374.115 67.5382 381.397 65.236 388.858 63.158C392.786 61.9978 395.298 59.6179 394.689 56.6477C394.492 55.8491 394.125 55.1134 393.587 54.4406C393.049 53.7679 392.403 53.3286 391.588 52.9522C390.772 52.5758 390.018 52.3698 389.158 52.3973C388.297 52.4248 387.499 52.6228 386.763 52.9912C378.629 55.6081 370.737 58.6196 362.791 61.7479C357.796 63.6897 357.392 63.6451 355.116 58.7733C352.956 53.9554 351.03 49.245 348.592 44.7234C348.054 44.0507 347.346 43.4409 346.53 43.0645C345.714 42.688 344.898 42.3116 343.983 42.4558C342.889 42.3758 341.624 44.1984 340.333 45.1595Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M197.727 83.3306C196.973 84.8749 196.506 86.6824 196.458 88.4303C196.53 90.2379 196.925 91.926 197.93 93.5062C198.936 95.0864 200.145 96.2236 201.749 97.1334C205.544 99.396 210.045 100.222 214.522 99.42C218.748 98.6538 222.483 96.6786 225.297 93.6259C226.314 94.5836 227.571 95.4335 229.056 96.1518C232.192 97.8158 235.807 98.2228 239.195 97.1454C242.583 96.068 245.456 93.8055 247.12 90.669C247.707 89.4599 247.97 88.0832 247.958 86.7184C247.946 85.3537 247.659 83.989 247.156 82.7918C246.594 81.4271 245.875 80.3975 244.822 79.4758C243.768 78.554 242.619 77.8596 241.35 77.3808L241.302 77.4886C238.01 76.1478 234.395 76.0281 230.959 77.2013C228.852 77.8717 226.949 79.0688 225.392 80.6251C224.71 79.823 223.896 79.2004 222.974 78.7575C219.73 76.7703 215.887 75.7048 212.104 75.9083C208.226 76.052 204.562 77.4048 201.522 79.7392L201.246 79.4638C199.726 80.3496 198.529 81.6786 197.727 83.3306Z'
          fill='#ABB8FF'
        />
        <path
          className='animated-microbe'
          d='M161.243 68.8537C161.721 68.4256 162.197 68.1702 162.85 67.9327C164.066 67.3542 165.293 66.7823 166.517 66.0212C167.662 65.1632 168.801 64.3151 170.035 63.5607C173.266 61.3538 176.49 59.1567 179.799 57.0466C183.291 54.9445 186.191 52.1807 188.574 48.8351C190.956 45.4895 192.442 41.7387 193.03 37.7554C193.871 34.0596 194.998 30.2828 196.3 26.6967C197.173 24.1931 198.678 21.8005 201.912 22.7047C205.146 23.6089 205.267 26.4387 204.66 29.0639C203.811 32.9423 202.501 36.7109 201.538 40.6715C200.585 44.6387 201.013 45.1168 205.202 45.3376C209.39 45.5583 214.85 45.8451 219.571 46.2824C220.764 46.2515 221.923 46.589 222.909 47.0978C224.148 47.894 224.884 49.304 225.359 50.6092C225.317 51.3327 225.007 51.9612 224.704 52.5798C224.305 53.1047 223.819 53.7154 223.166 53.9529C221.384 54.6832 219.364 54.9336 217.362 54.8355C212.983 54.7893 208.62 54.378 204.352 54.0604C199.807 53.641 196.234 55.457 192.811 58.0111C184.908 63.8918 176.734 69.4882 168.559 75.2572C167.89 75.8598 166.952 76.1781 166.109 76.5901C163.857 77.5659 161.098 77.9669 159.965 75.3486C159.405 73.9564 159.303 72.4847 159.655 71.1327C159.991 70.1458 160.668 69.3606 161.432 68.8517L161.249 68.8438L161.243 68.8537Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M254.596 207.87C256.683 209.9 258.85 208.907 260.898 207.455C263.575 205.558 266.171 203.691 268.938 202.02C271.704 200.349 274.682 198.991 278.477 196.981C278.639 195.889 279.278 194.249 279.32 192.968C280.526 193.28 282.247 192.929 283.701 192.821C284.372 192.743 284.977 191.95 285.592 191.486C296.061 183.491 306.588 175.449 316.964 167.466C318.351 166.509 319.432 165.158 320.068 163.587C320.259 162.809 320.282 162 320.136 161.217C319.991 160.435 319.679 159.696 319.223 159.053C318.477 158.194 316.463 158.191 315.054 158.335C313.924 158.625 312.881 159.2 312.022 160.007C301.53 167.986 291.066 175.996 280.63 184.035C279.37 185.226 278.201 186.513 277.133 187.883C277.323 188.648 277.383 189.668 277.564 190.593C277.211 190.407 276.84 190.254 276.455 190.142C275.48 189.859 274.448 189.83 273.459 190.06C267.813 192.632 262.461 195.836 257.072 198.922C256.115 199.603 255.317 200.482 254.731 201.5C253.349 203.56 252.508 205.841 254.596 207.87Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M161.67 116.192C162.691 114.046 163.517 109.533 165.552 108.723C167.014 108.481 168.598 108.421 170.075 109.001C171.542 109.587 172.837 110.303 173.878 111.479C178.671 119.775 182.401 128.719 186.495 137.39C187.118 139.159 187.252 141.007 187.085 142.801C186.988 146.769 186.017 150.416 181.741 151.349C177.321 152.251 175.556 148.954 174.335 145.257C172.685 140.485 171.031 135.723 169.043 131.064C167.054 126.405 164.549 121.986 161.664 116.181L161.67 116.192Z'
          fill='#FF9898'
        />
        <path
          className='animated-microbe'
          d='M181.834 201.31C177.378 199.072 172.907 199.737 168.854 198.949C167.291 198.816 165.748 198.218 164.322 197.327C163.727 196.77 163.202 196.079 162.858 195.3C162.514 194.521 162.32 193.796 162.164 192.937C162.444 192.241 162.716 191.537 163.13 190.895C163.545 190.254 164.181 189.863 164.96 189.519C166.938 189.01 168.949 188.833 170.995 188.986C175.944 189.154 176.195 188.931 176.094 184.221C176.001 183.219 175.971 182.075 176.074 180.986C176.445 178.387 177.494 175.738 180.424 176.091C182.272 176.333 183.871 178.414 185.561 179.879C185.926 180.176 186.01 181.186 186.078 181.848C186.289 187.891 189.428 192.67 192.748 197.361C196.784 203.136 200.679 208.849 204.519 214.713C205.22 215.797 206.071 216.937 206.165 217.938C206.263 219.744 205.745 221.475 204.665 222.981C204.029 223.371 203.107 223.653 202.294 223.666C201.489 223.671 200.588 223.487 199.892 223.207C197.372 221.408 195.203 219.109 193.277 216.579C190.516 212.91 188.249 208.805 185.543 205.002C184.523 203.478 183.261 202.167 181.693 201.23L181.827 201.284L181.834 201.31Z'
          fill='#9BE2C0'
        />
        <path
          className='animated-microbe'
          d='M338.415 111.484C339.436 109.338 340.262 104.825 342.297 104.015C343.76 103.773 345.343 103.713 346.821 104.293C348.287 104.879 349.583 105.595 350.624 106.771C355.417 115.067 359.146 124.011 363.24 132.682C363.864 134.451 363.997 136.299 363.831 138.093C363.733 142.061 362.763 145.708 358.487 146.641C354.066 147.543 352.302 144.246 351.081 140.549C349.43 135.777 347.777 131.015 345.788 126.356C343.8 121.697 341.295 117.278 338.41 111.473L338.415 111.484Z'
          fill='#FF9898'
        />
        <path
          className='animated-microbe'
          d='M183.452 -1.77942C184.115 -4.61449 182.146 -5.9593 179.846 -6.9648C176.84 -8.28052 173.902 -9.54123 171.043 -11.0498C168.184 -12.5583 165.486 -14.4094 161.807 -16.6236C160.787 -16.199 159.053 -15.9014 157.934 -15.2767C157.579 -16.4704 156.391 -17.7634 155.548 -18.9539C155.135 -19.489 154.144 -19.5975 153.429 -19.8851C141.18 -24.7316 128.861 -29.6027 116.67 -34.3751C115.135 -35.0701 113.42 -35.2994 111.746 -35.0338C110.98 -34.7964 110.276 -34.3991 109.681 -33.8705C109.085 -33.342 108.613 -32.6944 108.297 -31.9716C107.946 -30.8899 108.983 -29.1626 109.832 -28.0302C110.663 -27.2116 111.694 -26.614 112.829 -26.2945C125.075 -21.4207 137.334 -16.5866 149.605 -11.7914C151.275 -11.3264 152.98 -10.9881 154.705 -10.7799C155.262 -11.3372 156.105 -11.9149 156.804 -12.5463C156.827 -12.1486 156.887 -11.7519 156.99 -11.3638C157.25 -10.3824 157.758 -9.48408 158.465 -8.75463C163.58 -5.24465 169.085 -2.31214 174.509 0.714051C175.586 1.18221 176.751 1.41287 177.924 1.38998C180.402 1.51113 182.79 1.05552 183.452 -1.77942Z'
          fill='#9BE2C0'
        />
      </g>
    </svg>
  );
};

export default OverviewWigglingMicrobesBackground;
